module.exports = __webpack_public_path__ + "img/status_pending.c847daec.png";